export const yapilandirma = {
  apiTabanUrl: import.meta.env.VITE_API_TABAN_URL ?? '/api',
  uygulamaAdi: 'EmanetX Yonetim',
};
